var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:( _obj = {
      'system-row': true 
  }, _obj[_vm.subscription.mode] = true, _obj )},[_vm._v("PRO")]),_c('div',{staticClass:"system-comment"},[_vm._v("$"+_vm._s(_vm.subscription.price)+"/m. | "+_vm._s(_vm.$t('subscription.active_until'))+" "+_vm._s(_vm._f("formatDate")(_vm.subscription.paid_until)))])])}
var staticRenderFns = []

export { render, staticRenderFns }